import { useQuery } from "@tanstack/react-query";
import axiosInstance from "./axiosInstanse";
import { enum_api_uri } from "../utils/enum";

export type OrderData = {
    운송장번호: string;
    날짜: string;
    발송및지불: string;
    출발지: string;
    도착지: string;
    idx: string;
    s_kind: string;
    s_pay_kind: string;
    s_cnt: number;
    s_weight: number;
    s_pay_company: string;
    s_pay_name: string;
    s_pay_tel: string;
    s_pay_post: string;
    s_pay_address: string;
    s_pay_address_detail: string;
    a_company: string;
    a_tel: string;
    a_part: string;
    a_part_sn: string;
    a_name: string;
    a_request: string;
    a_request2: string;
    f_company: string;
    f_tel: string;
    f_name: string;
    f_mobile: string;
    f_post: string;
    f_address: string;
    f_address_detail: string;
    f_dam_code: string;
    t_company: string;
    t_tel: string;
    t_name: string;
    t_mobile: string;
    t_post: string;
    t_address: string;
    t_address_detail: string;
    f_c_code: string;
    s_pay_company_code: string;
    t_c_code: string;
};

type GetAcceptedOrdersResponse = {
    statusCode: number;
    message: string;
    data: {
        order_list: OrderData[];
        total_count: number;
        last_page: number;
        [key: string]: any;
    };
};

export const useGetLastOrder = (searchText: string) => {
    return useQuery<{ order_list: OrderData[]; total_count: number; last_page: number }>({
        queryKey: ["useGetLastOrder", searchText],
        queryFn: async () => {
            const { data } = await axiosInstance.get<GetAcceptedOrdersResponse>(`${enum_api_uri.last_order}`, {
                params: {
                    searchText,
                },
            });
            return {
                order_list: data.data.order_list,
                total_count: data.data.total_count,
                last_page: data.data.last_page,
            };
        },
        placeholderData: prev => prev,
    });
};
